import { __assign, __rest } from "tslib";
import biLogger from '@wix/web-bi-logger';
import ddt from '@wix/da-ddt';
import { getReferrer, commitReferrer } from './referrer';
import { validateEvent } from './eventValidator';
var BiLogger = /** @class */ (function () {
    function BiLogger() {
        this.defaultOptions = {
            version: 'eclipse;major',
            platform: 'desktop',
        };
    }
    BiLogger.prototype.getLogger = function (contextData) {
        if (typeof window !== 'undefined') {
            this.defaultOptions.url = window.location.toString();
            if (document.referrer) {
                this.defaultOptions.referer = document.referrer;
            }
        }
        if (contextData) {
            this.defaultOptions.platform = contextData.isMobile
                ? 'mobile'
                : 'desktop';
            if (contextData.biClientId) {
                this.defaultOptions.client_id = contextData.biClientId;
            }
            if (contextData.useridUuid) {
                this.defaultOptions.uuid = contextData.useridUuid;
            }
            this.defaultOptions.requestid = contextData.requestId;
            this.defaultOptions.view = contextData.view;
            this.defaultOptions.component = contextData.component;
        }
        return biLogger
            .factory({ endpoint: 'da-client', trackSession: false })
            .updateDefaults(this.defaultOptions)
            .logger();
    };
    BiLogger.prototype.log = function (contextData, _a, needsValidation) {
        var _biLoggerVersion = _a._biLoggerVersion, // drop any internal use fields
        _value = _a._value, _rankIndex = _a._rankIndex, eventData = __rest(_a, ["_biLoggerVersion", "_value", "_rankIndex"]);
        if (needsValidation === void 0) { needsValidation = true; }
        // we are not supposed to send client events from server
        if (typeof window === 'undefined') {
            ddt.error('bilogger', 'Attempted to send client event in SSR, fix me now', eventData);
            return Promise.resolve();
        }
        // if a new pageview, time to save referrer
        if (eventData.evid === 99) {
            commitReferrer();
        }
        var myLogger = this.getLogger(contextData);
        var biData = __assign(__assign(__assign({}, this.defaultOptions), { referer: getReferrer() }), eventData);
        var logData = needsValidation && _biLoggerVersion !== 2
            ? validateEvent(biData)
            : biData;
        // you may need to instruct your browser to preserve logs to be able to
        // see these messages
        ddt.log('bilogger', "(evid: ".concat(logData.evid, ")"), logData, JSON.stringify(logData));
        // we are not supposed to send events from dev
        if (process.env.NODE_ENV !== 'production') {
            return Promise.resolve();
        }
        return myLogger.log(logData);
    };
    return BiLogger;
}());
export { BiLogger };
var logger = new BiLogger();
export default logger;
//# sourceMappingURL=BiLogger.logger.js.map